import './AttributeView.scss';

export { default } from './AttributeView';
